import { useGLTF } from '@react-three/drei';
import { useLoader, useFrame } from '@react-three/fiber';
import { ObjectLoader } from 'three';
import { d as defineSrc } from './index-CAxCDj_E.esm.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import 'clsx';
import 'react';
import './common-DBpCdW70.esm.js';

const Flower = () => {
  const model = useGLTF(defineSrc('flower.glb'));
  const lights = useLoader(ObjectLoader, defineSrc('flower-light.json'));
  useFrame(() => {
    model.materials['Tapestry WebGL'].map.offset.x += -1e-3;
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("primitive", {
      scale: 1.3,
      position: [0, -9, 0],
      object: model.scene
    }), /*#__PURE__*/jsx("primitive", {
      object: lights
    })]
  });
};

export { Flower as default };
//# sourceMappingURL=Flower-BiO5fjiT.esm.js.map
